import * as React from 'react';
import FormDropdown from './FormDropdown';
import { FieldRenderProps } from 'react-final-form';
import { DropdownProps } from '.';

/**
 * Component that renders a yes or no dropdown.
 *
 * @class YesNoDropdown
 * @extends {(React.Component<FieldRenderProps & DropdownProps>)}
 */
class YesNoDropdown extends React.Component<FieldRenderProps<any, HTMLInputElement> & DropdownProps> {
	private options: any;

	constructor(props) {
		super(props);

		this.options = [
			{ value: true, text: 'Yes' },
			{ value: false, text: 'No' },
		];
	}

	public render() {
		return <FormDropdown {...this.props} options={this.options} />;
	}
}

export default YesNoDropdown;
